import { createContext, useContext } from 'react';

const SectionContext = createContext(true);

export const SectionContextProvider = SectionContext.Provider;

export function useSectionOpened(): boolean {
  return useContext(SectionContext);
}
